import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { Link, NativeLink, Text } from 'main/ui'

interface ITextStylesProps {
  mapView?: boolean
}

function textStyles(props: ITextStylesProps) {
  const { mapView } = props

  return css`
    font-size: ${mapView ? '13px' : 'inherit'};
  `
}

export const ActionText = styled(Text)<ITextStylesProps>`
  ${textStyles}
`

export const ActionLink = styled(Link)<ITextStylesProps>`
  ${textStyles}
`

export const ActionNativeLink = styled(NativeLink)<ITextStylesProps>`
  ${textStyles}
`
